import { render, staticRenderFns } from "./loginModule.vue?vue&type=template&id=589f277c&scoped=true"
import script from "./loginModule.vue?vue&type=script&lang=js"
export * from "./loginModule.vue?vue&type=script&lang=js"
import style0 from "./loginModule.vue?vue&type=style&index=0&id=589f277c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f277c",
  null
  
)

export default component.exports